import { API } from "aws-amplify";
import { API_CANAL } from "./consts";

export const postWithTrace = async (request) => {
    const req = { ...request };
    try {
        const resp = await API.post(req.name, req.path, req.data);
        return resp;
    } catch (error) {
        return error.response.data;
    }
};
export const AmplifyApi = async (request) => {
    const req = { ...request };

    try {
        const response = await API.post(req.name, req.path, req.data);
        return response;
    } catch (error) {
        throw error;
    }
};

// creando una nueva conexion, TRABAJANDO:
export const conection = {
    get: async (path, name = API_CANAL) => {
        return await API.get(name, path, {});
    },

    post: async (path, data, name = API_CANAL) => {
        return await API.post(name, path, data);
    },

    patch: async (path, data, name = API_CANAL) => {
        return await API.patch(name, path, data);
    },
};
